import { toast } from "@/ui/use-toast";
import { PostgrestError } from "@supabase/supabase-js";

export function useErrorToast() {
  const showErrorToast = ({ error }: { error: Error | PostgrestError }) =>
    toast({
      title: "Oops!",
      variant: "destructive",
      description: error.message,
    });

  return { showErrorToast };
}
